import Helmet from 'react-helmet'
import IconButton from 'material-ui/IconButton'
import { Link } from 'react-router'
import { Nav } from 'components'
import SearchConsoleContainer from '../../containers/SearchConsoleContainer'

import './searchTrendsPage.scss'

export default class SearchTrendsPage extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    muiTheme: React.PropTypes.object.isRequired
  }

  render() {
    const palette = this.context.muiTheme.palette
    const isLegacyUser = this.context.currentUser.googleUserEmail &&
           !!this.context.currentUser.searchConsoleSite

    return (
      <div>
        <Helmet title='Plug in SEO Search Trends' />
        <Nav
          toolbarTitleText='Search trends'
          rightGroupComponents={[
          <a href="https://support.pluginuseful.com/hc/en-us/articles/23534811246484-What-metrics-are-tracked-in-my-SEO-trends" target="_blank">
            <IconButton 
              tooltip='Learn More' 
              iconClassName="material-icons"
              iconStyle={{ color: palette.alternateTextColor }}
            >
              info_outline
            </IconButton>
          </a>,
          isLegacyUser &&
            <Link key='settings' to="/plus/trends/settings">
              <IconButton
                tooltip='settings'
                iconClassName="material-icons"
                iconStyle={{ color: palette.alternateTextColor }}
              >
                Settings
              </IconButton>
            </Link>
          ]}
        />
        <div className="searchTrends">
          <div className="searchTrends__content">
            <SearchConsoleContainer />
          </div>
        </div>
      </div>
    )
  }  
}



// WEBPACK FOOTER //
// ./app/components/search_console/SearchTrendsPage.js